import fetch from "isomorphic-unfetch";
import { withRouter } from "next/router";

import { jobPostingSchema, organizationSchema } from "../utils/googleSchema";
import { ROOT_URL, JOB_SEATRCH_URL } from "../actions/types";
import Layout from "../components/Layout/Layout.react";
import JobDetails from "../components/JobDetails";

const Job = withRouter(
  ({
    job,
    router,
    recentJobs,
    title,
    description,
    organization,
    jobPostingSchema,
    organizationSchema,
  }) => {
    return (
      <Layout
        title={title}
        description={description}
        jobPosting={job}
        organization={job.organization}
        jobPostingSchema={jobPostingSchema}
        organizationSchema={organizationSchema}
      >
        <JobDetails jobDetails={job} recentJobs={recentJobs} />
      </Layout>
    );
  }
);

Job.getInitialProps = async (context) => {
  const jobQuery = context.query.id;
  const id = jobQuery.split("-").pop();
  let job = await fetch(`${JOB_SEATRCH_URL}/indexes/jobs/documents/${id}`, {
    method: "GET",
    headers: {
      Authorization:
        "Bearer d7723c2a8b93c98d4f8dd318a936b394d24adc876fe60b7f4853bb2e82c9",
    },
  });
  job = await job.json();

  // let recentJobs = await fetch(`${ROOT_URL}/api/recent-jobs`);
  // recentJobs = await recentJobs.json();
  const jobInfo = job;
  jobInfo["hiringOrganization"] = job.organization || "Savanna HR";
  return {
    job: job || {},
    recentJobs: [],
    organization: job.jobs ? job.organization : {},
    jobPostingSchema: jobPostingSchema(jobInfo) || {},
    organizationSchema: organizationSchema || {},
    title: `${job.title} jobs in ${job.location} - ${
      job.organization || "HireXL"
    }`,
    description: `${job.title} jobs in ${job.location} - HireXL India’s No.1 Edtech Job Portal. Explore Thousands of Openings in your desired locations Now!`,
  };
};

export default Job;
